// @ts-nocheck
import * as React from "react";

const ThreadRollingDieChanges: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="164.000000pt"
            height="186.000000pt"
            viewBox="0 0 164.000000 186.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,186.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M185 1559 c-10 -16 2 -70 25 -106 29 -48 66 -67 140 -73 l65 -5 0 -175 0 -175 -52 -5 c-63 -7 -114 -44 -152 -112 -34 -60 -21 -78 55 -78 l53 0 3 -43 3 -42 48 -3 47 -3 0 -209 c0 -114 3 -215 6 -224 5 -13 24 -16 103 -16 62 0 101 4 109 12 9 9 12 73 12 224 l0 213 48 3 c47 3 47 3 50 41 l3 37 73 0 c89 0 159 31 211 94 38 47 65 104 58 124 -6 15 -164 17 -178 3 -6 -6 -66 -11 -135 -12 l-125 -3 -3 160 -2 159 125 0 c84 -1 129 -5 137 -13 18 -18 174 -16 181 2 9 23 -41 112 -90 161 -71 72 -92 75 -479 75 -225 0 -335 -3 -339 -11z m730 -48 c42 -19 94 -71 120 -121 l16 -30 -60 0 c-33 0 -63 5 -66 10 -4 6 -56 10 -124 10 -95 0 -121 3 -131 15 -7 9 -22 15 -32 13 -19 -3 -19 -21 -21 -543 l-2 -540 -80 0 -80 0 -3 529 c-1 371 -6 533 -13 543 -7 7 -32 13 -61 13 -71 0 -113 21 -137 69 -12 22 -21 43 -21 46 0 3 147 5 328 5 295 0 331 -2 367 -19z m135 -499 c0 -12 -53 -83 -81 -109 -37 -34 -73 -43 -165 -43 -89 0 -88 1 -84 -52 1 -26 -1 -28 -35 -28 l-36 0 3 103 3 102 132 3 c101 2 134 6 143 17 13 16 120 22 120 7z m-630 -132 l0 -100 -29 0 c-28 0 -30 3 -33 43 l-3 42 -57 3 c-32 2 -58 6 -58 9 0 15 46 72 69 87 14 8 45 16 69 16 l42 0 0 -100z" />
                <path d="M884 1277 c-3 -8 -4 -54 -2 -103 l3 -89 290 0 290 0 0 100 0 100 -288 3 c-233 2 -288 0 -293 -11z m546 -92 l0 -65 -255 0 -255 0 0 65 0 65 255 0 255 0 0 -65z" />
            </g>
        </svg>
    );
};

export default React.memo(ThreadRollingDieChanges);
